
<div id="kt_header_mobile"
    class="header-mobile align-items-center {{currentTheme.baseSettings.header.mobileFixedHeader ? 'header-mobile-fixed':''}}">
    <button class="btn p-0 header-mobile-toggle" id="kt_aside_mobile_toggle" aria-label="Open navigation">
        <span class="svg-icon svg-icon-xl">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M4 6.5h16M4 12h16M4 17.5h16" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" />
            </svg>
        </span>
    </button>
    <a routerLink="/" target="_blank" class="header-mobile-logo">
        <ng-container *ngIf="!appSession.tenant || !appSession.tenant.logoId">
            <img class="itp-logo-light" [src]="'/assets/common/images/ITPUpdatedIcon2.svg'"
                alt="logo" height="28" />
            <img class="itp-logo-dark" [src]="'/assets/common/images/ITPUpdatedIcon2-dark.svg'"
                alt="logo" height="28" />
        </ng-container>
        <img *ngIf="appSession.tenant && appSession.tenant.logoId"
            [src]="remoteServiceBaseUrl + '/TenantCustomization/GetTenantLogo?skin=' + currentTheme.baseSettings.menu.asideSkin + '&tenantId=' + appSession.tenant.id + '&id=' + appSession.tenant.logoId"
            alt="logo" height="38" />
    </a>
    <universal-search class="header-mobile-search d-lg-none"></universal-search>
    <div class="d-flex align-items-center header-mobile-actions">
        <button ktToggle [options]="userMenuToggleOptions" class="btn btn-hover-text-primary p-0"
            id="kt_header_mobile_topbar_toggle">
            <span class="svg-icon svg-icon-xl">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                    <path
                        d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                </svg>
            </span>
        </button>
    </div>
</div>

<div [@routerTransition] class="d-flex flex-column flex-root">
    <div class="d-flex flex-row flex-column-fluid mt-md-1 mt-lg-12 mt-xl-15 page">
        <div id="kt_aside" ktOffcanvas [options]="menuCanvasOptions"
            class="aside aside-left aside-{{currentTheme.baseSettings.menu.fixedAside ? 'fixed':'static'}} app-side-nav d-flex flex-column flex-row-auto">
            <div id="kt_aside_menu_wrapper" class="aside-menu-wrapper flex-column-fluid">
                <side-bar-menu></side-bar-menu>
            </div>
            <div class="aside-collapse-footer">
                <button type="button" class="aside-collapse-toggle btn" id="kt_aside_toggle"
                    *ngIf="showAsideCollapseToggle" (click)="toggleLeftAside()"
                    [attr.aria-label]="isAsideCollapsed ? 'Expand side navigation' : 'Collapse side navigation'"
                    [attr.title]="isAsideCollapsed ? 'Expand side navigation' : 'Collapse side navigation'">
                    <svg class="aside-collapse-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                        viewBox="0 0 16 16" fill="none" aria-hidden="true">
                        <path d="M7.5 3.5L3 8l4.5 4.5" stroke="currentColor" stroke-width="1.5"
                            stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12.5 3.5L8 8l4.5 4.5" stroke="currentColor" stroke-width="1.5"
                            stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
            </div>
        </div>
        <div class="d-flex flex-column flex-row-fluid wrapper" id="kt_wrapper">
            <div id="kt_header"
                class="header header-{{currentTheme.baseSettings.header.desktopFixedHeader  ? 'fixed':'fixed'}} head--skin-{{currentTheme.baseSettings.header.headerSkin}} app-top-nav">
                <div class="{{containerClass}} d-flex align-items-stretch justify-content-end topbarAlign px-0">
                    <a routerLink="/" target="_blank" class="top-nav-logo d-none d-lg-flex">
                        <img class="itp-logo-light" src="/assets/common/images/ITPUpdatedIcon2.svg" alt="In Time PRO logo" />
                        <img class="itp-logo-dark" src="/assets/common/images/ITPUpdatedIcon2-dark.svg" alt="In Time PRO logo" />
                    </a>
                    <div class="topbar w-100" id="dropdown-hover-color-default">

                        <!-- ====================================================================================================== -->

                        <div *ngIf="!hideHeaderBreadcrumbs" class=" mr-auto d-flex align-items-center font-size-sm breadcrumb-container">
                            <ul *ngIf="breadcrumbs && breadcrumbs.length > 0 "
                                class='breadcrumb breadcrumb-transparent breadcrumb-dot font-weight-bolder p-0 my-2 fs-6 pt-6 pt-lg-0'>
                                <ng-container *ngFor="let breadcrumbItem of breadcrumbs; let i = index; trackBy: trackByIndex">
                                <li class='breadcrumb-item' *ngIf="shouldShowBreadcrumbItem(i)">
                                    <a *ngIf="breadcrumbItem.isLink()"
                                       (click)="goToBreadcrumb(breadcrumbItem)" class=' font-size-14'>
                                        {{ formatBreadcrumbText(breadcrumbItem.text) }}
                                    </a>
                                    <span *ngIf="!breadcrumbItem.isLink()" class='bold'  [ngClass]="!breadcrumbItem.isLink() ? 'user-select-none' : 'cursor-pointer'"  (click)="onClick(breadcrumbItem.text)">{{ formatBreadcrumbText(breadcrumbItem.text) }}</span>

                                    <div class="d-flex ml-2" *ngIf="breadcrumbItem.text == 'Products and Services' && productServiceSelectionTypeValue =='Products'">
                                        / <div *ngIf="isGranted('Pages.ProductService.CRUD'); else notGrantedProducts" class="dropdown product-service-type-dropdown" dropdown (isOpenChange)="onOpenChange($event)" id="caret" disabled="true">
                                            <a dropdownToggle class="p-0 font-weight-bolder ml-2" style="color: #0095DA; ">
                                                {{_defaultLayoutService.productSelectedHeading | localize}}
                                                <i class="la ml-2 font-weight-bold {{textForClass}} "
                                                   style="color: #0095DA; "></i>

                                            </a>
                                            <ul class="dropdown-menu dropdown-menu-right" id="tab1" *dropdownMenu>
                                                <li class="navi navi-hover h-25px ">
                                                    <a class="navi-item intime-open-sans cursor-pointer text-body"(click)="productSelectionType(1)">
                                                       <div class="navi-link">
                                                            <div class="navi-text">
                                                               <div class="font-weight-bold">
                                                                   {{"ActiveProducts" | localize}}
                                                               </div>
                                                           </div>
                                                       </div>
                                                   </a>
                                                 </li>

                                                <li *ngIf="isGranted('Pages.ProductService.CRUD')" class="navi navi-hover mt-2 h-25px ">
                                                    <a class="navi-item intime-open-sans cursor-pointer text-body"(click)="productSelectionType(2)">
                                                       <div class="navi-link">
                                                            <div class="navi-text">
                                                               <div class="font-weight-bold">
                                                                   {{"ArchivedProducts" | localize}}
                                                               </div>
                                                           </div>
                                                       </div>
                                                   </a>
                                                 </li>

                                                <li *ngIf="isGranted('Pages.ProductService.CRUD')" class="navi navi-hover mt-2 mb-2 h-25px ">
                                                    <a class="navi-item intime-open-sans cursor-pointer text-body"(click)="productSelectionType(3)">
                                                       <div class="navi-link">
                                                            <div class="navi-text">
                                                               <div class="font-weight-bold">
                                                                   {{"DeletedProducts" | localize}}
                                                               </div>
                                                           </div>
                                                       </div>
                                                   </a>
                                                 </li>
                                            </ul>
                                        </div>
                                        <ng-template #notGrantedProducts>
                                            <span class="ml-2">{{'ActiveProducts' |localize}}</span>
                                        </ng-template>
                                    </div>

                                    <div class="d-flex ml-2" *ngIf="breadcrumbItem.text == 'Products and Services' && productServiceSelectionTypeValue =='Services'">
                                        / <div *ngIf="isGranted('Pages.ProductService.CRUD'); else notGrantedServices" class="dropdown product-service-type-dropdown" dropdown (isOpenChange)="onOpenChange($event)" id="caret">
                                            <a dropdownToggle class="p-0 font-weight-bolder ml-2" style="color: #0095DA; ">
                                                {{_defaultLayoutService.serviceSelectedHeading | localize}}
                                                <i class="la ml-2 font-weight-bold {{textForClass}} "
                                                   style="color: #0095DA; "></i>

                                            </a>
                                            <ul class="dropdown-menu dropdown-menu-end " id="tab1" *dropdownMenu>
                                                <li class="navi navi-hover h-25px ">
                                                    <a class="navi-item intime-open-sans cursor-pointer text-body"(click)="serviceSelectionType(1)">
                                                       <div class="navi-link">
                                                            <div class="navi-text">
                                                               <div class="font-weight-bold">
                                                                   {{"ActiveServices" | localize}}
                                                               </div>
                                                           </div>
                                                       </div>
                                                   </a>
                                                 </li>

                                                <li *ngIf="isGranted('Pages.ProductService.CRUD')" class="navi navi-hover mt-2 h-25px ">
                                                    <a class="navi-item intime-open-sans cursor-pointer text-body"(click)="serviceSelectionType(2)">
                                                       <div class="navi-link">
                                                            <div class="navi-text">
                                                               <div class="font-weight-bold">
                                                                   {{"ArchivedServices" | localize}}
                                                               </div>
                                                           </div>
                                                       </div>
                                                   </a>
                                                 </li>

                                                <li *ngIf="isGranted('Pages.ProductService.CRUD')" class="navi navi-hover mt-2 mb-2 h-25px ">
                                                    <a class="navi-item intime-open-sans cursor-pointer text-body"(click)="serviceSelectionType(3)">
                                                       <div class="navi-link">
                                                            <div class="navi-text">
                                                               <div class="font-weight-bold">
                                                                   {{"DeletedServices" | localize}}
                                                               </div>
                                                           </div>
                                                       </div>
                                                   </a>
                                                 </li>
                                            </ul>
                                        </div>
                                        <ng-template #notGrantedServices>
                                            <span class="ml-2">{{'ActiveServices' |localize}}</span>
                                        </ng-template>
                                    </div>

                                    <div class="d-flex ml-2" *ngIf="breadcrumbItem.text == 'Dashboard' && !this.isCheckProfile">
                                        /
                                        <div class="dropdown" dropdown (isOpenChange)="uparrow=!uparrow" id="caret">
                                            <a dropdownToggle class=" p-0 font-weight-bolder ml-2"
                                               style="color: #0095DA; ">
                                                {{dashboardSelectedType | localize}}
                                                <i class="la ml-2 font-weight-bold"
                                                   [ngClass]=" uparrow ? 'la-angle-down' : 'la-angle-up'"
                                                   style="color: #0095DA; "></i>
                                            </a>
                                            <ul class="dropdown-menu dropdown-menu-right w-150px" *dropdownMenu >

                                                 <li class="navi navi-hover h-25px ">
                                                    <a class="navi-item intime-open-sans cursor-pointer text-body" (click)="selectedTabDashboard(0)" >
                                                       <div class="navi-link">
                                                            <div class="navi-text">
                                                               <div class="font-weight-bold">
                                                                   {{"MyDashboard" | localize}}
                                                               </div>
                                                           </div>
                                                       </div>
                                                   </a>
                                                 </li>
                                                <li class="navi navi-hover mt-2 mb-2 h-25px ">
                                                    <a class="navi-item intime-open-sans cursor-pointer text-body" (click)="selectedTabDashboard(1)" >
                                                       <div class="navi-link">
                                                            <div class="navi-text">
                                                               <div class="font-weight-bold">
                                                                   {{"TeamDashboard" | localize}}
                                                               </div>
                                                           </div>
                                                       </div>
                                                   </a>
                                                 </li>

                                            </ul>
                                        </div>

                                    </div>

                                    <div *ngIf="breadcrumbItem?.text == 'Dashboard  /' &&  isCheckProfile" id="check-color">
                                        <span class=" ml-3 font-weight-bolder intime-open-sans mt-1 bg-font-color">My Dashboard</span>

                                    </div>

                                </li>
                                </ng-container>
                            </ul>

                        </div>

                        <universal-search class="topbar-universal-search"></universal-search>

                        <!-- ====================================================================================================================== -->
                        <div class="bg-white d-flex topbar-menus">
                            <div class="topbar-item subscription-warning d-print-none "
                                 *ngIf="!isMobileDevice() && subscriptionStatusBarVisible()">
                                <subscription-notification-bar></subscription-notification-bar>
                            </div>

                            <active-delegated-users-combo *ngIf="!installationMode"></active-delegated-users-combo>
                            <quick-theme-selection></quick-theme-selection>
                            <theme-mode-toggle></theme-mode-toggle>

                            <div *ngIf="!this.isClient" [ngClass]="{'isSidebarChecklandingPageTopbar': !isLoginForFirstTime}">
                                <app-setting-topbar></app-setting-topbar>
                            </div>
                            <help-menu></help-menu>
                            <div *ngIf="!this.isClient"
                                 [ngClass]="{'isSidebarChecklandingPageTopbar': !isLoginForFirstTime}">
                                <app-downloadfile></app-downloadfile>
                            </div>

                            <header-notifications></header-notifications>

                             <div *ngIf="isProfileData" class="d-flex align-items-center">
                            <user-menu></user-menu>
                        </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="p-3 mobile-subscription-warning d-print-none"
                *ngIf="isMobileDevice() && subscriptionStatusBarVisible()">
                <subscription-notification-bar></subscription-notification-bar>
            </div>

                <!-- min-height:0 + overflow-auto: flex child must shrink so page content can scroll (overflow-hidden blocked all routes) -->
                <div class="flex-grow-1 overflow-auto app-content-shell" style="min-height: 0">
                    <router-outlet></router-outlet>
                </div>

        </div>
    </div>
</div>
